export default __webpack_public_path__ + "static/media/Vector Smart Object.aeea3d5e.svg";